const state = {
    giftList: [],
    giftInfoMap: {},
    targetList: [],
    currentTarget: 0,
    currentCount: '1',
    strBiggiftPlayUrlList: [],//['http://localhost:8080/kun.mp4', 'http://localhost:8080/kun.mp4']
}
const mutations = {
    GIFT_UPDATE_GIFT_INFO(state, data) {
        state.giftList = data
        for (let index = 0; index < data.length; index++) {
            state.giftInfoMap[array[index].gift_id] = array[index];
        }
    },
    GIFT_ADD_TARGET_INFO(state, data) {
        var bFound = false;
        for (let index = 0; index < state.targetList.length; index++) {
            const element = state.targetList[index];
            if (element.value == data.value) {
                bFound = true;
                break;
            }
        }
        if (!bFound) {
            state.targetList.push(data);
        }
    },
    GIFT_REMOVE_TARGET_INFO(state, uid) {
        var arrnew = [];
        for (let index = 0; index < state.targetList.length; index++) {
            const element = state.targetList[index];
            if (element.value == uid) {
                continue;
            }
            arrnew.push(data);
        }
        state.targetList = arrnew.slice();
    },
    GIFT_UPDATA_COUNT_VALUE(state, data) {
        state.currentCount = data;
    },
    GIFT_UPDATA_TARGET_VALUE(state, data) {
        state.currentTarget = data;
    },
    GIFT_CLEAR_TARGET(state, data) {
        state.targetList = [];
        state.currentTarget = "";
    },
    GIFT_ADD_BIGGIFTPLAYURL(state, data) {
        state.strBiggiftPlayUrlList.push(data);
    },
    GIFT_UPDATE_BIGGIFTPLAYURL_REMOVE_TOP(state) {
        let newList = [];
        for (let index = 1; index < state.strBiggiftPlayUrlList.length; index++) {
            const element =  state.strBiggiftPlayUrlList[index];
            newList.push(element);
        }
        state.strBiggiftPlayUrlList = newList.slice();
    }

}

// this message is similar to post message. It's async
const actions = {
    gift_update_gift_info({
        commit
    }, data) {
        commit('GIFT_UPDATE_GIFT_INFO', data)
    },

    gift_Add_Target_Info({
        commit
    }, data) {
        commit('GIFT_ADD_TARGET_INFO', data)
    },
    gift_Remove_Target_Info({
        commit
    }, data) {
        commit('GIFT_REMOVE_TARGET_INFO', data)
    }
}
const getters = {
    getGiftInfoByID: (state) => (id) => {
        let b = state.giftInfoMap[id];
        if (b == null) {
            b = state.giftList.find((e) => (e.gift_id == id))
        }
        return b
    },
}
export default {
    state,
    mutations,
    actions,
    getters
}